// React
import { useState } from "react"

// Maps
import {
	AdvancedMarker,
	InfoWindow,
	useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps"

// Translations
import { useTrans } from "@/i18n"

// UI
import { FiCalendar } from "@/lib/icons"

// Images
import ImageMapsMarkerInstallation from "@/assets/icons/maps_marker_installation.svg"

/**
 * MarkerWithInfowindow
 *
 * DOCS: https://developers.google.com/maps/documentation/get-map-id
 * DOCS: https://developers.google.com/maps/documentation/javascript/advanced-markers/migration
 *
 * @returns
 */
export const MarkerWithInfowindow = ({
	position,
	name,
	type,
	start,
	imageUrl,
}: {
	position: { lat: number; lng: number }
	name: string
	type?: string | null
	start?: string | null
	imageUrl?: string | null
}) => {
	const [infowindowOpen, setInfowindowOpen] = useState(false)
	const [markerRef, marker] = useAdvancedMarkerRef()
	const t = useTrans("common")

	return (
		<>
			<AdvancedMarker
				ref={markerRef}
				onClick={() => setInfowindowOpen(true)}
				position={position}
				title={name}
			>
				<img src={ImageMapsMarkerInstallation} alt={name} />
			</AdvancedMarker>
			{infowindowOpen && (
				<InfoWindow
					anchor={marker}
					maxWidth={320}
					onCloseClick={() => setInfowindowOpen(false)}
				>
					<div className="overflow-hidden">
						{/* Project image */}
						{imageUrl && (
							<div className="-mx-3 -mt-3 mb-3">
								<img // TODO: Replace this with lazy loading images
									className="block h-[100px] w-full bg-gray-300"
									alt={name}
									src={imageUrl}
								/>
							</div>
						)}

						{/* Project type badge - matches ProjectCard */}
						{type && (
							<div className="bg-primary-500 mb-2 inline-block rounded-md px-3 py-1 text-xs font-bold text-black opacity-90">
								{t(`common:project.type.${type}`)}
							</div>
						)}

						{/* Project name - matches ProjectCard heading style */}
						<h3 className="mb-3 text-base font-semibold text-gray-900">
							{name}
						</h3>

						{/* Project details - matches ProjectCard info style */}
						<div className="space-y-2 text-sm text-gray-600">
							{start && (
								<div className="flex items-center gap-2">
									<FiCalendar className="size-4 shrink-0 text-gray-400" />
									<span className="truncate">
										{new Date(start).toLocaleString()}
									</span>
								</div>
							)}
						</div>
					</div>
				</InfoWindow>
			)}
		</>
	)
}
